import React from 'react';
import { connect as connectFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import * as componentStyles from './FaqHero.style';

const FaqHero = ({ styles }) => (
    <section className={styles.wrapper}>
        <div className={styles.inner}>
            <h1 className={styles.title}>
                <FormattedMessage id="faq.hero.title" />
            </h1>
            <p className={styles.subtitle}>
                <FormattedMessage id="faq.hero.subtitle" />
            </p>
        </div>
    </section>
);

export default connectFela(componentStyles)(FaqHero);
